import React, { useEffect } from 'react';
import { useMsal } from '@azure/msal-react';
import PropTypes from 'prop-types';
import { ADOPERATIONS, ROUTES } from '@constants/index';
import utils from '@utils';
import { SplashScreen } from '@components';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import { thunks } from '@redux/app';

const ADCallback = ({ history, loginWithAD }) => {
	const { instance } = useMsal();

	const setActiveAccount = (account) => {
		instance.setActiveAccount(account);
		localStorage.setItem('homeAccountId', account.homeAccountId);
	};

	const callback = () => {
		const { lang } = global;

		instance.handleRedirectPromise()
			.then((accessTokenResponse) => {
				if (accessTokenResponse) {
					setActiveAccount(accessTokenResponse.account);
					switch (utils.decodeADState(accessTokenResponse.state).operation) {
						case ADOPERATIONS.changePassword:
							utils.notify({
								type    : 'success',
								message : 'Password successfully reset',
								timeOut : 1500,
							});
							history.push(ROUTES.account);
							break;

						case ADOPERATIONS.login:
							loginWithAD();
							break;

						case ADOPERATIONS.signup:
							history.push(ROUTES.signupConfirmation);
							break;

						default:
							history.push(ROUTES.root);
							break;
					}
				}
			})
			.catch((error) => {
				if (!utils.isADCancellation(error)) {
					utils.notify({
						type    : 'error',
						message : lang.t('Something went wrong with the authentication system'),
						timeOut : 1500,
					});
				}
				history.push(ROUTES.root);
			});
	};

	useEffect(() => {
		callback();
	}, []);

	return (
		<div id="ad-signup">
			<SplashScreen />
		</div>
	);
};

const mapDispatchToProps = (dispatch) => ({
	loginWithAD : bindActionCreators(thunks, dispatch).loginWithAD,
});

ADCallback.propTypes = {
	history     : PropTypes.object.isRequired,
	loginWithAD : PropTypes.func.isRequired,
};

export default connect(null, mapDispatchToProps)(ADCallback);
